import { createStore } from 'vuex'
import router from '@/router/index'
import type { stateInfo } from './handle'
// import VuexPersistence from 'vuex-persist'
// const vuexLocal = new VuexPersistence({
//   storage: window.localStorage
// })
export default createStore({
  state: {
    myroutes: [],
    changeOptionalTime: 0,
    loginInfo: {
      token: '',
      serverId: ''
    },
    OptionalList: [],

    iframeModalInfo: {
      width: '948px',
      modalsrc: '',
      modalvisible: false,
      title: ''
    },
    pcqueryInfo: {
      subjectCode: '',
      appcode: '',
      serverid: '',
      appversion: ''
    },
    breadcrumbList: JSON.parse(sessionStorage.getItem('breadcrumbList') || '[]') || []
  },
  mutations: {
    FRESH_MYROUTES(state: stateInfo, params: any) {
      state.myroutes = params
      router.addRoute(router.options.routes[0])
    },
    setOptionalShareslist(state: stateInfo, params: any) {
      state.OptionalList = params
    },

    setLoginInfo(state: stateInfo, params: { token: string, serverId: string }) {
      state.loginInfo = params
    },
    setChangeOptionalTime(state: stateInfo, params: number) {
      state.changeOptionalTime = params
    },
    setIframeModalInfo(state: stateInfo, params: { modalvisible: boolean, modalsrc: string, title: string, width: string }) {
      state.iframeModalInfo = params
    },
    // PC 传过来的部分参数，有需要再加
    setPcqueryInfo(state: stateInfo, params: { subjectCode: string, appcode: string, serverid: string, appversion: string }) {
      state.pcqueryInfo = params
    },
    setBreadcrumbList(state: stateInfo, params: any) {
      state.breadcrumbList = params
      sessionStorage.setItem('breadcrumbList', JSON.stringify(params))
    },
    clearBreadcrumbList(state: stateInfo) {
      state.breadcrumbList = []
      sessionStorage.setItem('breadcrumbList', JSON.stringify([]))
    }
  },
  actions: {
  },
  modules: {
  }
  // plugins: [vuexLocal.plugin]
})
